import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

/** Respuesta de GET /pages/:pgid/time-off-balance */
export type TimeOffBalanceResponse = {
	uid: string;
	policy: {
		id: string;
		name: string;
		type: PGSchema.hcm_time_off_policy["type"];
		allowance_type: PGSchema.hcm_time_off_policy["allowance_type"];
		allowance_amount: number;
		negative_counter: boolean;
		carryover_days: number;
		carryover_expires_months: number;
		available_days: PGSchema.hcm_time_off_policy["available_days"];
		accrued_units_availability: PGSchema.hcm_time_off_policy["accrued_units_availability"];
	} | null;
	balance: {
		year: number;
		cycleStart: string;
		cycleEnd: string;
		accrued: number;
		carryover: number;
		usable: number;
		taken: number;
		pending: number;
		committed: number;
		available: number;
	} | null;
	validates_balance: boolean;
};

export type TimeOffRequestCreateBody = {
	uid: PGSchema.hcm_time_off_requests["uid"];
	start_date: string;
	end_date: string;
	type: string;
	total_days: number;
	first_half_day?: boolean | null;
	status?: string;
	delegate_uid?: string;
};

export type TimeOffRequestUpdateBody = Partial<{
	type: PGSchema.hcm_time_off_requests["type"];
	start_date: string;
	end_date: string;
	total_days: PGSchema.hcm_time_off_requests["total_days"];
	first_half_day: PGSchema.hcm_time_off_requests["first_half_day"];
	delegate_uid: string;
}>;

export class TimeOffRequests {
	/** Balance anual aproximado (misma heurística que la tarjeta lateral). */
	async getBalance(pgid: PGSchema.pages["id"], params?: { uid?: string }, token?: string) {
		return xget<TimeOffBalanceResponse>(`/pages/${pgid}/time-off-balance`, params, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async getAll(
		pgid: PGSchema.pages["id"],
		params?: {
			from_ts?: number;
			to_ts?: number;
			/** Ventana de solapamiento (epoch ms); deben enviarse juntos con `within_to_ts`. */
			within_from_ts?: number;
			/** Ventana de solapamiento (epoch ms); deben enviarse juntos con `within_from_ts`. */
			within_to_ts?: number;
			uid?: string;
			status?: string;
			/** personal | team — team = solicitudes que puedo aprobar (validado en servidor) */
			scope?: "personal" | "team";
		},
		token?: string
	) {
		return xget<{ items: PGSchema.hcm_time_off_requests[] }>(`/pages/${pgid}/time-off-requests`, params, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async getOne(pgid: PGSchema.pages["id"], itemId: PGSchema.hcm_time_off_requests["id"], token?: string) {
		return xget<PGSchema.hcm_time_off_requests>(`/pages/${pgid}/time-off-requests/${itemId}`, undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async create(pgid: PGSchema.pages["id"], data: TimeOffRequestCreateBody, token?: string) {
		return xhttp<PGSchema.hcm_time_off_requests>(`/pages/${pgid}/time-off-requests`, "POST", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async update(pgid: PGSchema.pages["id"], itemId: PGSchema.hcm_time_off_requests["id"], data: TimeOffRequestUpdateBody, token?: string) {
		return xhttp<PGSchema.hcm_time_off_requests>(`/pages/${pgid}/time-off-requests/${itemId}`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async updateStatus(pgid: PGSchema.pages["id"], itemId: PGSchema.hcm_time_off_requests["id"], status: PGSchema.hcm_time_off_requests["status"], token?: string) {
		return xhttp<PGSchema.hcm_time_off_requests>(
			`/pages/${pgid}/time-off-requests/${itemId}/status`,
			"PUT",
			{ status },
			{
				headers: token ? { "app-token": token } : undefined
			}
		);
	}

	async delete(pgid: PGSchema.pages["id"], itemId: PGSchema.hcm_time_off_requests["id"], token?: string) {
		return xhttp<{ deleted: boolean }>(
			`/pages/${pgid}/time-off-requests/${itemId}`,
			"DELETE",
			{},
			{
				headers: token ? { "app-token": token } : undefined
			}
		);
	}
}
